import { useState } from "react";
import { useTranslation } from "react-i18next";

function CreateSchoolProfileContainer() {
  const { i18n, t } = useTranslation();
  const [, setIsScrolled] = useState(false);
  const [, setIsScrolled_] = useState(false);
  const handleScrollToContainer = (componentId: string) => {
    const container = document.getElementById(componentId);
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
      setIsScrolled(true);
      setIsScrolled_(true);
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0);

  let list = [
    {
      title: `${t("schoolInfo.container.primaryInformation")}`,
      componentId: "info",
    },
    {
      title: `${t("schoolInfo.container.otherInformation")}`,
      componentId: "anotherInfo",
    },
    {
      title: `${t("aboutSchool.container.aboutSchool")}`,
      componentId: "aboutSchool",
    },
    {
      title: `${t("schoolInfo.container.schoolPicture")}`,
      componentId: "SchoolGallery",
    },
    {
      title: `${t("schoolInfo.container.attachment")}`,
      componentId: "SchoolAtachments",
    },
    {
      title: `${t("schoolInfo.container.socialMediaAccounts")}`,
      componentId: "SocialMediaAccs",
    },
  ];

  return (
    <div id="info">
      <div
        className={`${
          i18n.language === "ar" ? "mr-8" : "ml-8"
        } flex flex-col w-[209px] rounded-lg bg-white h-fit drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)] mobile:hidden`}
      >
        <div className="mobile:hidden">
          {list.map((item, index) => {
            return (
              <div
                className={`${
                  index === currentIndex
                    ? `${
                        i18n.language === "ar" ? "border-r-2" : "border-l-2"
                      } border-mint-500`
                    : ""
                } font-ar text-lg h-12`}
              >
                <div
                  className={`${
                    index === currentIndex ? "text-mint-500" : "text-zinc700"
                  } p-2.5`}
                  onClick={() => {
                    setCurrentIndex(index);
                    handleScrollToContainer(item.componentId);
                  }}
                >
                  {item.title}
                </div>
                <div
                  className={` ${
                    index === list.length - 1
                      ? "border-t-0"
                      : "border-t-[0.3px] border-zinc300"
                  }`}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
      <button
        className={`${
          i18n.language === "ar" ? "mr-11" : "ml-11"
        } mt-11 border rounded-xl bg-mint-500 p-2 text-white font-ar w-[162px] mobile:mr-0 mobile:mt-0`}
      >
        {t("app.shared.save")}
      </button>
    </div>
  );
}

export default CreateSchoolProfileContainer;
